<template>
  <gc-main-layout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :selectedIndex="selectedIndex"
    :baseView="baseView"
    :formsConfig="formsConfig"
    :key="baseView.mode"
    :hot-key-create-path="`/supplier-type/create`"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
  >
    <template #headerContent>
      <GcHeaderContentStatic title="Supplier Type" />
    </template>
    <div>
      <gc-split-view
        :showLeftContainer="showLeftContainer"
        :showRightContainer="showRightContainer"
      >
        <template #leftContent>
          <div>
            <gc-filter-split-view
              :showLeftContainer="showFilterLeftContainer"
              :showRightContainer="showFilterRightContainer"
            >
              <template #leftContent>
                <dx-data-grid
                  :data-source="dataSourceConfig"
                  :columns="columns"
                  :height="gridHeight"
                  @row-click="onRowClicked($event, rowSelect)"
                  @toolbar-preparing="onToolbarPreparing($event)"
                  @context-menu-preparing="
                    onContextMenuPreparing($event, rowSelect)
                  "
                  @content-ready="addGridNoResults($event)"
                  :selection="{ mode: 'single' }"
                  @exporting="onGridToExcelExporting($event, `Supplier Type`, columns)"
                >
                  <DxExport :enabled="true" />
                  <template #active-cell-template="{ data }">
                    <GcInactive :inactive="data.data.Inactive" />
                  </template>

                  <template #supplier-type-cell-template="{ data }">
                    <GcDescriptionCodeCellTemplate
                      :description="data.data.Description"
                      :code="data.data.Code"
                    />
                  </template>
                </dx-data-grid>
              </template>
              <template #rightContent>
                <gc-advance-filter-panel
                  :toolbar="filterToolbar"
                  :setFilterFormHeight="filterFormHeight"
                  :sideBarTabs="sideBarTabs"
                  :filterFormItems="filterFormItems"
                  :filterModel="getAdvanceFilterModel"
                  :isJson="false"
                  :screenType="'supplier-contact-list'"
                  :data-source-config="dataSourceConfig"
                >
                </gc-advance-filter-panel>
              </template>
            </gc-filter-split-view>
          </div>
        </template>

        <template #rightContent>
          <DxToolbar class="split-view-toolbar">
            <DxItem #default location="before" locate-in-menu="never">
              <div class="toolbar-label">
                <span class="text-primary">{{ model.Code }}</span>
              </div>
            </DxItem>
            <DxItem
              widget="dxForm"
              location="after"
              :options="{
                formData: model,
                items: toolbarActiveItems,
                validationGroup: 'toolbarActive',
                labelLocation: 'left',
              }"
              locate-in-menu="after"
              :disabled="baseView.mode == 'review' ? true : false"
            ></DxItem>
            <DxItem
              :options="toolbar.audit"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              v-if="baseView.mode == 'review'"
            />
            <DxItem
              :options="toolbar.edit"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              :visible="formsConfig.editableOption"
              v-if="baseView.mode == 'review'"
            />
            <DxItem
              :options="toolbar.save"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              v-if="baseView.mode != 'review'"
            />
            <DxItem
              :options="toolbar.close"
              location="after"
              widget="dxButton"
            />
          </DxToolbar>
          <div class="view-card responsive-paddings">
            <form>
              <DxForm
                :form-data.sync="model"
                :read-only="false"
                :show-colon-after-label="false"
                :show-required-mark="false"
                :show-validation-summary="false"
                :validation-group="formsConfig.validationGroup"
                :col-count-by-screen="formsConfig.splitViewColCountByScreen"
                label-location="left"
                :customizeItem="customizeItem"
                :items="items"
              ></DxForm>
            </form>
          </div>
        </template>
      </gc-split-view>
    </div>
  </gc-main-layout>
</template>

<script>

import BaseViewMixin from "../../../v1/_mixins/base.view";
import validationEngine from "devextreme/ui/validation_engine";
import { SupplierTypeService } from "../../../_services/api/settings/suppliers/supplier-type.service";

export default {
  components: { },
  mixins: [BaseViewMixin],
  updated() {
    if (this.showRightContainer) {
      validationEngine.validateGroup(this.formsConfig.validationGroup);
      validationEngine.validateGroup("toolbarActive");
    }
  },
  created() {
    this.selectedIndex = 0;
    setTimeout(() => {
      if (this.showRightContainer) {
        validationEngine.validateGroup(this.formsConfig.validationGroup);
        validationEngine.validateGroup("toolbarActive");
      }
    }, 250);
  },
  data() {
    return {
      toolbar: {
        close: {
          icon: "close",

          onClick: () => {
            this.$router.push({
              path: "/supplier-type",
            }).then((res) => {
                if (res)
                  setTimeout(() => {
                    this.reSizeGrid();
                  }, 50);
              });
          },
        },
        advanceFilterModel: {
          Inactive: "",
        },
        edit: {
          icon: "edit",

          onClick: () => {
            this.$router.push({
              path: `/supplier-type/edit/${this.baseView.id}`,
            });
          },
        },
        save: {
          icon: "floppy",
          validationGroup: "formsData",
          onClick: (e) => {
            this.$logger.trackEventButtonClickSave();
            this.saveSupplierType(e);
          },
        },
        audit: {
          icon: "clock",

          onClick: () => {
            this.displayAuditPopup(
              this.model.CreatedBy,
              this.model.DateCreated,
              this.model.ChangedBy,
              this.model.DateChanged
            );
          },
        },
      },
      model: {
        Code: "",
        Description: "",
        Active: true,
        DateChanged: "",
        DateCreated: "",
        ChangedBy: "",
        CreatedBy: "",
      },

      rowSelect: {
        view: this,
        page: "supplier-type",
        mode: "review",
        idProperty: "Code",
      },
    };
  },
  computed: {
    getAdvanceFilterModel() {
      return this.advanceFilterModel;
    },
    filterFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 1,
          items: this.parseFormColumns([
            {
              dataField: "Inactive",
              gcType: "String",
              editorType: "dxTagBox",
              gcLabel: "Status",
              editorOptions: {
                items: [
                  {
                    text: "Active",
                    value: "N",
                  },
                  {
                    text: "Inactive",
                    value: "Y",
                  },
                ],
                valueExpr: "value",
                displayExpr: "text",
              },
            },
          ]),
        },
      ];
    },
    columns() {
      return this.parseGridColumns("master", [
        {
          gcLabel: "Type",
          dataField: "Description",
          cellTemplate: "supplier-type-cell-template",
          gcType: "String",
          gcSubType: "PrimaryRecord",
          gcExport: ["Code", "Description"],
        },
        {
          gcLabel: "Changed By",
          dataField: "ChangedBy",
          gcType: "String",
          width: 120,
        },
        {
          gcType: "String",
          gcSubType: "Chip",
          dataField: "Inactive",
          cellTemplate: "active-cell-template",
        },
        {
          gcLabel: "Code",
          dataField: "Code",
          width: 120,
          gcType: "String",
          gcSubType: "HiddenCode",
        },
        {
          gcLabel: "Description",
          dataField: "Description",
          minWidth: this.gridColumnMinWidth(220),
          gcType: "String",
          gcSubType: "HiddenDescription",
        },
      ]);
    },
    items() {
      let formFields = [
        {
          itemType: "group",
          caption: "",
          items: this.parseFormColumns([
            {
              dataField: "Code",
              visible: this.baseView.mode == "create",
              gcLabel: "Type",
              gcType: "String",
              editorType: "dxTextBox",
              editorOptions: {
                maxLength: 2,
              },
              required: true,
            },
            {
              dataField: "Description",
              gcLabel: "Description",
              gcType: "String",
              editorType: "dxTextBox",
              editorOptions: {
                maxLength: 100,
              },
              required: true,
            },
          ]),
        },
      ];

      return formFields;
    },
    toolbarActiveItems() {
      return this.parseFormColumns([
        {
          dataField: "Active",
          gcType: "Boolean",
          gcLabel: "Active",
        },
      ]);
    },
    dataSourceConfig() {
      return SupplierTypeService.dataSourceConfig("api/SupplierType", {
        select: ["Code", "Description", "Inactive", "ChangedBy"],
        // sort: [{ selector: "Code", desc: false }],
      });
    },
    tabs() {
      return [
        {
          text: "Supplier Type",
          path: `/supplier-type`,
          applicationFeatureCode: "SupplierType",
        },
      ];
    },
    showLeftContainer() {
      return !(this.isXSmall && this.baseView.mode !== "");
    },
    showRightContainer() {
      return !(this.baseView.mode == "review" && this.baseView.id == "");
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler: "handleLocalRouteChange",
    },
  },
  methods: {
    backButtonFunction() {
      this.$router.push({
        path: "/settings/suppliers",
      });
    },
    onToolbarPreparing(e) {
      var toolbarItems = e.toolbarOptions.items;
      var searchPanel = toolbarItems.find((item) => {
        return item.name === "searchPanel";
      });
      var exportButton = toolbarItems.find((item) => {
        return item.name === "exportButton";
      });
      var columnChooserButton = toolbarItems.find((item) => {
        return item.name === "columnChooserButton";
      });

      e.toolbarOptions.items = toolbarItems.filter((item) => {
        return (
          item.name !== "exportButton" &&
          item.name !== "searchPanel" &&
          item.name !== "columnChooserButton"
        );
      });

      searchPanel.location = "after";
      exportButton.location = "after";
      e.toolbarOptions.items.unshift(
        {
          location: "before",
          widget: "dxButton",
          options: {
            icon: "plus",
            text: "Add New",
            onClick: () => {
              this.$logger.trackEventButtonClickAddNew();
              this.model.Code = "";
              this.model.Description = "";
              this.model.Active = true;
              this.$router.push({
                path: "/supplier-type/create",
              });
            },
          },
        },
        searchPanel,
        exportButton,
        columnChooserButton,
        {
          location: "after",
          locateinmenu: "auto",
          widget: "dxButton",
          options: {
            validationGroup: "formsData",
            icon: "filter",
            elementAttr: { id: "filter-btn" },
            onClick: () => {
              this.showFilterRightContainer = !this.showFilterRightContainer;
              var item = document.getElementById("filter-btn");
              this.$logger.debug("item ", item);
              item.classList.add("dx-state-invisible");
            },
          },
        }
      );
    },
    handleLocalRouteChange() {
      // let that = this;
      if (
        (this.baseView.mode === "review" || this.baseView.mode === "edit") &&
        this.baseView.id
      ) {
        this.model.Code = this.baseView.id;
        this.getRecord().then((response) => {
          if (response.data.value.length > 0) {
            this.model.Code = response.data.value[0].Code;
            this.model.Description = response.data.value[0].Description;
            this.model.Active = response.data.value[0].Inactive == "N";
            this.model.DateChanged = response.data.value[0].DateChanged;
            this.model.DateCreated = response.data.value[0].DateCreated;
            this.model.ChangedBy = response.data.value[0].ChangedBy;
            this.model.CreatedBy = response.data.value[0].CreatedBy;
            // that.refreshView();
          }
        });
      }
    },
    async getRecord() {
      return SupplierTypeService.getByCode(this.baseView.id);
    },
    async saveSupplierType(e) {
      const result = await e.validationGroup.validate();
      if (!result.isValid) {
        this.displayValidationSummary();
        return;
      }

      this.showLoading(true);

      await SupplierTypeService.save(this.baseView.mode, {
        Code: this.model.Code,
        Description: this.model.Description,
        Inactive: this.model.Active ? "N" : "Y",
      })
        // eslint-disable-next-line no-unused-vars
        .then((res) => {
          this.showLoading(false);
          // eslint-disable-next-line no-console
          // this.$logger.debug("saveSupplierType", res);
          this.$notify(
            `Supplier Type ${this.model.Code} saved successfully`,
            "success"
          );
          this.setIgnoreRouteChangeConfirmation();
          this.$router.push({
            path: `/supplier-type/review/${this.model.Code}`,
          });
        })
        .catch((error) => {
          this.displayServerError(error, "Supplier Type save failed");
        });
    },
  },
};
</script>
